<div class="container welcome">
  <nav class="panel">
    <h2 class="panel-heading welcome-heading">
      Find out my flood risk
    </h2>
    <div class="panel-block welcome-content">
      <div class="welcome-section">
        <p>Use this interactive map to see how your suburb can be affected by floods of different sizes from the Hawkesbury-Nepean River. This map is best viewed with Chrome, Safari, or your mobile browser.</p>
        <p>For information on local flooding or flash flooding, or for property-level flood information, please contact your local council.</p>
      </div>
      <div class="welcome-section welcome-controls" class:is-ready={isMapLoaded}>
        <div class="welcome-controls-item">
          <Checkbox id={'tnc'} name={'tnc'} on:toggle={toggleAgreeTnC}>
            <p>I agree to the <a target="_blank" class="welcome-condition-use" href={tncUrl}>conditions of use</a></p>
          </Checkbox>
        </div>
        <div
          class="welcome-btns welcome-controls-item" >
          <button
            on:click|preventDefault={toggleShow}
            class="button is-link"
            disabled={!canEnterApp}>
            Get Started
          </button>
          <!-- <button
            on:click|preventDefault={startTour}
            class="button is-primary"
            disabled={!canEnterApp}>
            Take tour
          </button> -->
        </div>
      </div>
    </div>
  </nav>
</div>



<script>
import { pathOr } from "ramda";
import store, { STATES_MAIN, STATES_FIRST_VISIT } from "../../state";
import storage from "../../services/StorageService";
import qs from "qs";
import Checkbox from "../../shared/components/Checkbox/Checkbox.svelte";
Checkbox;
// html vars
let canEnterApp = false;
let isMapLoaded;
let tncUrl = "https://www.ses.vic.gov.au/web/www/disclaimer";
// script vars
let isAlreadyInStateState = true;
store.subscribe(state => {
    isAlreadyInStateState = state.currentState.includes(`${STATES_MAIN.START}.`);
    isMapLoaded = state.mapViewService.isReady();
    canEnterApp = pathOr(false, ["tncAcccepted"], state);
    tncUrl = pathOr("", ["config", "tncUrl"], state);
});
// Add cookie here
function toggleAgreeTnC(e) {
    store.update(state => {
        state.tncAcccepted = !state.tncAcccepted;
        storage.setItem("ses-tnc", state.tncAcccepted);
        return state;
    });
}
function toggleShow(e) {
    if (!isAlreadyInStateState) {
        const qsObj = qs.parse(window.top.location.search, {
            ignoreQueryPrefix: true
        });
        const appState = qsObj.as || undefined;
        store.update(state => {
            state.currentState = appState
                ? appState
                : `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCH}`;
            return state;
        });
    }
}
// function startTour(e: MouseEvent) {
//   store.update(state => {
//     state.currentState = `${STATES_MAIN.TOUR}.${STATES_TOUR.DEFAULT}`;
//     return state;
//   });
// }
</script>


<style>.panel-heading{border-color:#1d3b78}.panel-block{flex-direction:column;align-items:stretch;background-color:#fff;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.welcome{flex-grow:0}.welcome-heading{padding:1rem .8125rem;border-radius:.5rem .5rem 0 0;font-size:1.125rem;text-transform:uppercase;text-align:center;line-height:25px;font-family:AvenirLT-Black}.welcome-content{padding:1.8125rem;border-radius:0 0 .5rem .5rem;box-shadow:0 5px 20px 0 rgba(0,0,0,.5);font-family:Helvetica}.welcome-section{font-size:.875rem;line-height:20px;color:#363636}.welcome-section>p:last-of-type{margin-top:1.25rem}.welcome-section+.welcome-section{margin-top:1.75rem}.welcome-btns{margin-top:1.4375rem;display:flex}.welcome-btns .button{height:36px;width:120px;font-size:.75rem;border-radius:.25rem;line-height:16px;padding:.59375rem 0}.welcome-btns .button.is-link:disabled{background-color:#a8a8a8}.welcome-btns .button+.button{margin-left:1rem}.welcome-controls{pointer-events:none;position:relative}.welcome-controls:before{content:"";position:absolute;top:calc(50% - 2px);left:calc(50% - 2px);width:4px;height:4px;border-radius:50%;background:#f08403;-webkit-animation:loader 1.2s cubic-bezier(.165,.84,.44,1) infinite;animation:loader 1.2s cubic-bezier(.165,.84,.44,1) infinite;display:block}.welcome-controls.is-ready{pointer-events:auto}.welcome-controls.is-ready:before{display:none}.welcome-controls.is-ready .welcome-controls-item{font-family:AvenirLT-Light,Helvetica,sans-serif;-webkit-animation:fadein-up .2s cubic-bezier(.165,.84,.44,1) forwards;animation:fadein-up .2s cubic-bezier(.165,.84,.44,1) forwards}.welcome-controls.is-ready .welcome-controls-item:first-child{-webkit-animation-delay:.3s;animation-delay:.3s}.welcome-controls.is-ready .welcome-controls-item:nth-child(2){-webkit-animation-delay:.4s;animation-delay:.4s}.welcome-controls-item{opacity:0;font-size:.75rem}.welcome-condition-use{text-decoration:underline;font-family:AvenirLT-Medium,Helvetica,sans-serif}</style>
